// extracted by mini-css-extract-plugin
export var lgBreak = "1200";
export var mdBreak = "992";
export var smBreak = "768";
export var textarea = "TextArea-module--textarea--58638";
export var textareaLabel = "TextArea-module--textareaLabel--92b8b";
export var xsBreak = "480";